import { useState, useEffect } from 'react';
import { CommonTableProps } from './Types';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { Table, TableColumnsType } from 'antd';

interface PaginatedTableProps extends CommonTableProps {
  columns: TableColumnsType<any>;
  defultPageSize?: number;
  defultPage?: number;
}

const PaginatedTable = ({
  getDataAction,
  columns,
  defultPage = 1,
  defultPageSize = 10,
  refresh,
  setRefresh,
}: PaginatedTableProps) => {
  const [data, setData] = useState<
    {
      [key: string]: string;
    }[]
  >([]);
  const [pageSize, setPageSize] = useState(defultPageSize);
  const [currentPage, setcurrentPage] = useState(defultPage);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffectCancelled(
    (canceller) => () => {
      getData(canceller);
    },
    [currentPage, pageSize]
  );

  useEffectCancelled(
    (canceller) => () => {
      if (refresh) {
        getData(canceller);
        setRefresh && setRefresh();
      }
    },
    [refresh]
  );

  const getData = (canceller: AbortController) => {
    // setNewAdd('')
    setLoading(true);
    getDataAction(canceller, currentPage, pageSize)
      .then((res) => {
        setTotalCount(res.totalCount);
        setData(res.data);
      })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Table
        loading={loading}
        pagination={{
          size: 'small',
          showSizeChanger: true,
          showQuickJumper: true,
          total: totalCount,
          pageSize: pageSize,
          onChange: (pageNumber: number, pageSize: number) => {
            setPageSize(pageSize);
            setcurrentPage(pageNumber);
          },
        }}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
};

export default PaginatedTable;
